import { render, staticRenderFns } from "./education.html?vue&type=template&id=e70af09c&scoped=true&external"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70af09c",
  null
  
)

export default component.exports